import React from 'react'

interface JsonViewerProps {
    data: any
    title?: string
}

const JsonViewer: React.FC<JsonViewerProps> = ({ data, title }) => {
    return (
        <div className="w-full">
            {title && (
                <h3 className="text-lg font-semibold mb-4 text-gray-700">
                    {title}
                </h3>
            )}
            <div className="bg-gray-50 rounded-lg p-4 border">
                <pre className="whitespace-pre-wrap text-sm text-gray-800 font-mono overflow-auto max-h-96">
                    {JSON.stringify(data, null, 2)}
                </pre>
            </div>
        </div>
    )
}

export default JsonViewer
